import { CheckboxGroup, RadioGroup } from "@chakra-ui/react";

type RadioOrCheckboxGroupProps = {
  children: JSX.Element;
  multipleChoice: boolean;
  onChange: (values: string[]) => void;
  values: string[];
};

const RadioOrCheckboxGroup = (props: RadioOrCheckboxGroupProps) => {
  return (
    <>
      {props.multipleChoice ? (
        <CheckboxGroup onChange={props.onChange} value={props.values}>
          {props.children}
        </CheckboxGroup>
      ) : (
        <RadioGroup
          onChange={(value) => props.onChange([value])}
          value={0 < props.values?.length ? props.values[0] : ""}
          paddingBottom="10"
        >
          {props.children}
        </RadioGroup>
      )}
    </>
  );
};

export default RadioOrCheckboxGroup;
